export default __webpack_public_path__ + "static/omni-4-a-1e6ec67f4b13f11fef7a8b580d5d35f7.webp";